import { useCallback, useMemo, useState } from 'react';

import { UserDetail } from '@atom/types/user';

export type UseImpersonationResponse = {
  impersonatedUser: UserDetail | null;
  setImpersonatedUser: (user: UserDetail | null) => void;
  clearImpersonation: () => void;
  getImpersonatedUserId: () => string | null;
};

export const useImpersonation = (): UseImpersonationResponse => {
  const [impersonatedUser, setImpersonatedUser] = useState<UserDetail | null>(
    null,
  );

  const clearImpersonation = useCallback(() => {
    setImpersonatedUser(null);
  }, []);

  const getImpersonatedUserId = useCallback(() => {
    return impersonatedUser?.id ?? null;
  }, [impersonatedUser]);

  return useMemo(
    () => ({
      impersonatedUser,
      setImpersonatedUser,
      clearImpersonation,
      getImpersonatedUserId,
    }),
    [impersonatedUser, clearImpersonation, getImpersonatedUserId],
  );
};
